export const SPA_BASE_PATH = import.meta.env.VITE_APPLICATION_BASE_PATH || '/';

export const DEFAULT_LOCALE = import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'en-GB';
export const API_V4_BASE_URL = import.meta.env.VITE_API_V4_URL;
export const DESKTOP_VIEWPORT_MIN_SCREEN_WIDTH = 769;
export const CHECK_OUT_URL = import.meta.env.VITE_CHECKOUT;
